export default __webpack_public_path__ + "static/media/angers3.23b76072.jpg";